import React, { useState, useEffect } from 'react';
import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';
import PropTypes from 'prop-types';
import { Accordion } from '@uhg-abyss/web/ui/Accordion';
import { Button } from '@uhg-abyss/web/ui/Button';
import { styled } from '@uhg-abyss/web/tools/styled';
import { event } from '@uhg-abyss/web/tools/event';
import { facetChangeEvent } from '../events';

const ShowMoreButton = styled(Button, {
  color: '$interactive1',
});

const ShowCheckBox = styled(Checkbox, {
  '&.abyss-c-hmJUPt': {
    fontWeight: 'normal',
    marginBottom: '0px',
  },
});

export const FilterBox = ({
  filterTitle,
  controller,
  setIsFacetSelected,
  selectedFacets,
  setSelectedFacets,
}) => {
  const [filters, setFilters] = useState(controller.state);

  useEffect(() => {
    controller.sortBy('alphanumeric');
    controller.subscribe(() => setFilters(controller.state));
  }, [controller]);

  const handleFacetToggle = (item, title) => {
    const isValueSelected = !controller?.isValueSelected(item);
    controller.toggleSelect(item);

    if (isValueSelected) {
      setIsFacetSelected(true);
      setSelectedFacets((prev) => {
        const updatedFacets = [
          ...prev,
          { fieldName: title, value: item.value },
        ];
        event.setData(
          facetChangeEvent({
            searchEventTrigger: 'facetSelect',
            searchFacetValues: updatedFacets,
          })
        );
        return updatedFacets;
      });
    } else {
      // remove unselected filter - if match between fieldName and value is found, return false
      const filteredFacets = (selectedFacets || []).filter(
        (facet) => !(facet.fieldName === title && facet.value === item.value)
      );

      event.setData(
        facetChangeEvent({
          searchEventTrigger: 'facetDeselect',
          searchFacetValues: filteredFacets,
        })
      );
      setSelectedFacets(filteredFacets);
      if (filteredFacets.length < 1) {
        setIsFacetSelected(false);
      }
    }
  };

  return (
    <Accordion.Item value={filterTitle}>
      <Accordion.Trigger>{filterTitle}</Accordion.Trigger>
      <Accordion.Content>
        <If condition={filters.values.length > 0}>
          <div>
            <For each="item" of={filters.values}>
              <ShowCheckBox
                key={item}
                label={item.value}
                isChecked={controller.isValueSelected(item)}
                onChange={() => handleFacetToggle(item, filterTitle)}
              />
            </For>
            <If condition={filters.canShowMoreValues}>
              <ShowMoreButton
                variant="tertiary"
                onClick={() => controller.showMoreValues()}
              >
                Show More
              </ShowMoreButton>
            </If>
          </div>
        </If>
      </Accordion.Content>
    </Accordion.Item>
  );
};

FilterBox.propTypes = {
  filterTitle: PropTypes.string,
  controller: PropTypes.shape({
    state: PropTypes.shape({}),
    subscribe: PropTypes.func.isRequired,
    toggleSelect: PropTypes.func.isRequired,
    isValueSelected: PropTypes.func.isRequired,
    sortBy: PropTypes.func.isRequired,
    showMoreValues: PropTypes.func.isRequired,
  }),
  setIsFacetSelected: PropTypes.func.isRequired,
  setSelectedFacets: PropTypes.func.isRequired,
  selectedFacets: PropTypes.arrayOf(PropTypes.shape({})),
};

FilterBox.defaultProps = {
  filterTitle: '',
  controller: {
    state: {},
  },
  selectedFacets: [],
};
